<template>
  <v-card>
    <v-card-title>
      <v-flex>
        <h1>Tournament List</h1>
        <v-switch label="Live tournaments only" v-model="liveFilter"></v-switch>
      </v-flex>
    </v-card-title>

    <v-data-table :headers="headers" :items="filteredTournaments" :pagination.sync="pagination" :loading="loading" hide-actions>
      <template slot="items" slot-scope="{ item }">
        <tr @click="rowClick(item)" style="cursor: pointer">
          <td>
            <img class="hidden-sm-and-down" style="height: 35px" v-if="item.logos && item.logos.competitionIcon" :src="logoUrl(item.logos.competitionIcon)" alt="">
            <span>{{ item.name }}</span>
          </td>
          <td>{{ item.gender ? 'Women' :  'Men' }}</td>
          <td class="hidden-sm-and-down">{{ item.startDateMainDraw }}</td>
          <td class="hidden-sm-and-down">{{ item.endDateMainDraw }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { QueryBuilder } from '@fivb/sdk'

export default {
  data: () => ({
    loading: true,
    headers: [
      { text: 'Name', value: 'name', sortable: true, },
      { text: 'Gender', value: 'gender', sortable: true, },
      { text: 'Start Date', value: 'startDateMainDraw', sortable: true, class: 'hidden-sm-and-down', },
      { text: 'End Date', value: 'endDateMainDraw', sortable: true, class: 'hidden-sm-and-down', },
    ],
    pagination: {
      sortBy: 'startDateMainDraw',
      rowsPerPage: -1,
    },
    tournaments: [],
    liveFilter: true,
  }),

  async created () {
    const season = new URLSearchParams(document.location.search.substring(1)).get('season') || '2026'
    const query = new QueryBuilder('BeachTournament')
      .filterBy('Season', season)
      .fetch(['No', 'Name', 'Gender', 'StartDateMainDraw', 'EndDateMainDraw', 'Status', 'Logos', 'shortNameOrName'])

    const { data } = await fetch(process.env.VUE_APP_FIVB_API_URL, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-store',
      headers: new Headers({
        'Content-Type': 'application/xml',
        'Accept': 'application/json',
        'X-FIVB-App-ID': '3b665ad61056495ab5514b81eb0562d8'
      }),
      body: query,
    }).then(response => response.json())

    this.loading = false
    this.tournaments = data
  },

  computed: {
    filteredTournaments: function () {
      if (!this.liveFilter) {
        return this.tournaments
      }

      return this.tournaments.filter((tournament) => {
        return tournament.status === 6
      })
    },
  },

  methods: {
    rowClick ({ no }) {
      this.$router.push({ name: 'TournamentMatchList', params: { id: no } })
    },

    logoUrl (id) {
      return `https://www.fivb.org/Vis2009/Images/GetImage.asmx?No=${id}&MaxSize=150`
    },

  },
}
</script>




// WEBPACK FOOTER //
// src/components/TournamentList.vue